import type { AddressBody, MapboxFeature } from '../types';

export const adaptMapboxFeatureToAddressBody = (mapboxFeature: MapboxFeature): Partial<AddressBody> => {
    const { properties } = mapboxFeature;
    const { context } = properties;

    return {
        addressNumber: context.address?.address_number,
        alternate: context.region?.alternate?.name,
        country: context.country?.name,
        countryCode: context.country?.country_code,
        fullAddress: properties.full_address,
        latitude: properties.coordinates.latitude,
        longitude: properties.coordinates.longitude,
        mapboxId: properties.mapbox_id,
        place: context.place?.name,
        postcode: context.postcode?.name,
        region: context.region?.name,
        streetName: context.street?.name,
    };
};
